import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import ApiService from "../../services/ApiService";
import InvoiceList from "../InvoiceList";
import InvoicePopup from "../InvoicePopup";

export default function Invoices() {
    const [invoices, setInvoices] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [isInvoicePopupOpen, setIsInvoicePopupOpen] = useState(false);
    const [searchParams] = useSearchParams("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        localStorage.setItem('loading', loading);
    }, [loading])

    const fetchInvoices = async () => {
        setLoading(true);
        try {
            const data = await ApiService.getInvoices();
            setInvoices(data.invoices);
            const paymentId = searchParams.get('payment_id');
            if (paymentId) {
                const invoice = data.invoices.find(
                    (inv) => inv.razorpay_payment_id === paymentId
                );
                if (invoice) {
                    setSelectedInvoice(invoice);
                    setIsInvoicePopupOpen(true);
                }
            }
        } catch (error) {
            toast.error("Failed to fetch invoices.");
        } finally {
            setLoading(false);
        }
    };

    const handleSelectInvoice = (invoice) => {
        setSelectedInvoice(invoice);
        setIsInvoicePopupOpen(true);
    };

    useEffect(() => {
        fetchInvoices();
    }, []);

    console.log("here is the invoices list", invoices);

    return (
        <div className="min-h-screen bg-white px-4">
            <h1 className="text-3xl font-bold text-gray-900 mb-6">Invoices</h1>
            <InvoiceList invoices={invoices} onSelectInvoice={handleSelectInvoice} />
            {isInvoicePopupOpen && (
                <InvoicePopup
                    invoice={selectedInvoice}
                    onClose={() => setIsInvoicePopupOpen(false)}
                    loading={loading}
                />
            )}
        </div>
    );
}
